"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const modal_1 = __importStar(require("@clayui/modal"));
const global_context_1 = __importDefault(require("@ocp/global-context"));
const ModalHeader_1 = __importDefault(require("./ModalHeader"));
const types_1 = require("./types");
const Modal = (props) => {
    const { title: headerTitle, className, size, titleSize, status, iconStatus, center, scrollable, headerBorderless, buttons, visible: visibleFromOuter, zIndex, onClose: onCloseOuter, children, spritemap, url, iFrameProps, } = props;
    const [visible, setVisible] = (0, react_1.useState)(visibleFromOuter);
    const prevVisibleOuterRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        prevVisibleOuterRef.current = visibleFromOuter;
    });
    const prevVisibleFromOuter = prevVisibleOuterRef.current;
    const { observer, onClose: close } = (0, modal_1.useModal)({
        onClose: () => {
            setVisible(false);
            onCloseOuter();
        },
    });
    (0, react_1.useEffect)(() => {
        if (!prevVisibleFromOuter && visibleFromOuter) {
            setVisible(true);
        }
        else if (prevVisibleFromOuter && !visibleFromOuter && visible) {
            close();
        }
    }, [prevVisibleFromOuter, visibleFromOuter, visible, close]);
    return visible ? (react_1.default.createElement(modal_1.default, { observer: observer, spritemap: spritemap, className: className, size: size, status: status, center: center, zIndex: zIndex },
        react_1.default.createElement(ModalHeader_1.default, { title: headerTitle, titleSize: titleSize, status: status, icon: iconStatus, borderless: headerBorderless, onClose: close }),
        react_1.default.createElement(modal_1.default.Body, { url: url, iFrameProps: iFrameProps, scrollable: scrollable }, children),
        buttons && react_1.default.createElement(modal_1.default.Footer, { last: buttons }))) : null;
};
Modal.defaultProps = {
    title: undefined,
    className: undefined,
    size: undefined,
    titleSize: types_1.ModalTitleSize.Large,
    status: undefined,
    iconStatus: undefined,
    center: undefined,
    scrollable: undefined,
    headerBorderless: undefined,
    buttons: undefined,
    zIndex: undefined,
    spritemap: global_context_1.default.spriteMapPath,
    url: '',
    iFrameProps: {},
};
exports.default = Modal;
//# sourceMappingURL=Modal.js.map